import { css } from "lit-element";
export default css `
  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    margin-top: 1rem;
  }

  .col-md-6, .col-lg-4 {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px; }

  @media (min-width: 768px) {
    .col-md-6 {
      flex: 0 0 50%;
      max-width: 50%; } }

  @media (min-width: 992px) {
  .col-lg-4 {
      flex: 0 0 33.33333%;
      max-width: 33.33333%; } }

  footer {
    padding: 15px 0;
    color: #666;
    border-top: 1px solid #e5e5e5;
  }

  footer p {
    margin: 0;
  }
`;
